<div class="flex" [ngClass]="formControl.errors && formControl.dirty ? 'mb-0' : 'mb-6'" *ngIf="!this?.props?.hidden">
  <om-checkbox class="w-full"
    [control]="formControl"
    [label]="props.label"
    [icon]="props.icon"
    [value]="props.value"
  ></om-checkbox>
</div>
